import React, { useCallback, useMemo, useState } from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import ChangeVmInstanceTypeDialog from './ChangeVmInstanceTypeDialog'
import EditVmDialog from './EditVmDialog'

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    display: 'inline-block',
    cursor: 'pointer',
  },
}))

export default function EditResourcesButton({ vm }) {
  const classes = useStyles()
  const [showModal, setShowModal] = useState(false)

  const DialogComponent = useMemo(() => {
    return vm?.spec?.instancetype?.name ? ChangeVmInstanceTypeDialog : EditVmDialog
  }, [vm])

  const handleClick = useCallback(() => {
    setShowModal(true)
  }, [setShowModal])

  return (
    <>
      <div className={classes.icon} onClick={handleClick}>
        <FontAwesomeIcon size="md">edit</FontAwesomeIcon>
      </div>
      {showModal && <DialogComponent onClose={() => setShowModal(false)} rows={[vm]} />}
    </>
  )
}
